export const EMPTY_IMPORT_READY = Object.freeze({
  ok: false,
  requests: 0,
  messages: 0,
  questions: 0
});

const COUNT_FIELDS = ["requests", "messages", "questions"];

/**
 * Normalizes wrapped API-v2 and legacy unwrapped referral import counts.
 *
 * @param {Object} payload API response data or its nested data property
 * @returns {Object|null} Normalized counts, or null when the payload is malformed
 */
export const normalizeImportReady = payload => {
  const source = payload?.data ?? payload;
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return null;
  }

  const counts = COUNT_FIELDS.map(field => Number(source[field]));
  if (counts.some(value => !Number.isFinite(value) || value < 0 || !Number.isInteger(value))) {
    return null;
  }

  return {
    ok: source.ok !== false,
    requests: counts[0],
    messages: counts[1],
    questions: counts[2]
  };
};

export const hasImportableItems = importReady => {
  const normalized = normalizeImportReady(importReady);
  return normalized ? COUNT_FIELDS.some(field => normalized[field] > 0) : false;
};
